import {EventBus} from "../../EventBus";

export const handleForceDisconnect = () => {
    EventBus.emit('destroyInstance');
};